import { render, staticRenderFns } from "./TabProfessional.vue?vue&type=template&id=07ebc290&scoped=true&"
import script from "./TabProfessional.vue?vue&type=script&lang=js&"
export * from "./TabProfessional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ebc290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ebc290')) {
      api.createRecord('07ebc290', component.options)
    } else {
      api.reload('07ebc290', component.options)
    }
    module.hot.accept("./TabProfessional.vue?vue&type=template&id=07ebc290&scoped=true&", function () {
      api.rerender('07ebc290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabProfessional.vue"
export default component.exports